import { useState, useEffect } from 'react';
import './App.css';
import Conectando from './comun/Conectando.jsx';
import Login from './comun/Login.jsx';
import Admon from './admon/Index.jsx';
import Beneficiarios from './usuarios/index.jsx';
import Asesores from './asesores/index.jsx';
import { io } from 'socket.io-client';
import { RUTA_SERVER } from './componentes/config.js';
import Modal from './comun/VentanaModal.jsx'


/**Inicio conectándome al servidor index.js del backend */
const socket = io(RUTA_SERVER);


function App() {
  const [pantalla, setPantalla] = useState('conectando')
  const [perfil, setPerfil] = useState([])

  /** Para el manejo de la ventana de mensajes modal**/
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState([]);
  const [btn, setBtn] = useState('');
  const [pregunta, setPregunta] = useState('');
  const handleClose = () => setShow(false);


  /*** Actualiza un campo del perfil ***/
  const actualizarCampoPerfil = (campo, valor) => {
    setPerfil({...perfil, [campo]: valor});
  }

  /**Esta función es llamada desde el Login */
  const acceder = (datosPerfil) => {
    setPerfil(datosPerfil);
    if(datosPerfil.TipoParticipante===1){   //Super
      setPantalla('admon')
      
    }else if(datosPerfil.TipoParticipante===2){   //Equipo de trabajo
      setPantalla('asesor')

    }else{                                        //Beneficiarios
      setPantalla('beneficiario');

    }  
    
  }

  const cerrarSesion=()=>{
    setPantalla('login')
  }

  /**Comienzo a escuchar los mensajes a través del socket */
  useEffect(()=>{
    socket.on("connect", () =>{
       setPantalla('login')
    })

    socket.on("autenticado", (datos) =>{
      console.log("Llego al App despues de autenticarse con los siguientes datos")
      console.log(datos)
    })

    return () => {
      socket.off("connection")
    }
  },[])


  const mostrarMsg = (msg, btn, pregunta)=>{
    setMsg(msg)
    if(btn!==undefined) setBtn(btn)
    if(pregunta!==undefined) setPregunta(pregunta)
    setShow(true)
  }

  const mostrarPantalla = () =>{
    switch (pantalla) {
      case 'conectando':
        return <Conectando /> 
      case 'login':
          return <Login acceder={acceder} socket={socket} mostrarMsg={mostrarMsg} /> 
      case 'admon':
        return <Admon perfil={perfil} socket={socket} acceder={acceder} actualizarCampoPerfil={actualizarCampoPerfil}  mostrarMsg={mostrarMsg} cerrarSesion={cerrarSesion}/> 
      case 'beneficiario':
        return <Beneficiarios perfil={perfil} acceder={acceder} socket={socket} mostrarMsg={mostrarMsg} cerrarSesion={cerrarSesion} actualizarCampoPerfil={actualizarCampoPerfil}/> 
      case 'asesor':
          return <Asesores perfil={perfil} acceder={acceder} socket={socket} mostrarMsg={mostrarMsg} cerrarSesion={cerrarSesion} actualizarCampoPerfil={actualizarCampoPerfil}/> 
      default:
        return <Conectando /> 
    }
  }


  return (
    <div className="container-fluid">
      {mostrarPantalla()}
      <Modal show={show} handleClose={handleClose} msg={msg} boton={btn} pregunta={pregunta}/>
    </div> 
    
  );
}

export default App;